import type { FaireProductEntity } from "../../entity_types/product";

export const p_1mkj76zunv: FaireProductEntity = {
  token: "p_1mkj76zunv",
  type: "product",
  name: "Dinosaur Bath Bomb for Kids (1 Pack)",
  brandToken: "b_on2vzm5lxj",
  brandName: "Two Sisters Spa",
  imageUrl:
    "https://cdn.faire.com/fastly/cda447ccb51fbd489366a82dfdbfe8347ab06f8bb97369c30d48002d103f9628.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a543fdcc0f31a52700c7f03887f03970a1206f58c92f4c27f50c480d532b79e3.jpeg",
    "https://cdn.faire.com/fastly/3149cb8018ffe85d40b3306e32487bae02249f6b7be8f61a54dfa451ffeb0065.png",
    "https://cdn.faire.com/fastly/588774e1375b8f9f645dcc36cec6541697f2ccf82a2eceda105f0ae5b0347ae7.jpeg",
    "https://cdn.faire.com/fastly/33f749e3482e9c9bb90f1483b144e7a09aef854f35a17adcc10b7a60e757522d.jpeg",
    "https://cdn.faire.com/fastly/d5a747a220d6e2de2af4549900b48ef8ba45c37a283a31159828b2d3d8b4bf42.jpeg",
    "https://cdn.faire.com/fastly/1a3dd47414b86bdbf74048ab566b9b89a0433c5406d9715a0651795b03493939.jpeg",
  ],
  priceDollars: 4.5,
  description:
    "Fizzing Fun & Colorful Splendor: Witness the magic of our bath bombs, unveiling squishy toy surprises. Immerse in a bath full of colors and bubbles, lasting 5 to 8 minutes—longer than off-brands.\n\nWhimsical Treasures Await: Delight in discovering different dinosaurs in every bomb! Fizzing excitement enchants kids as they dissolve and unveil endless squishy joys.\n\nGentle Care, Trusted Ingredients: Skin-safe elements that won't leave stains or rings in the tub. Our “SLSa” formula, free from common irritants, ensures kids' safety. Crafted in the USA.\n\nGifts Wrapped in Joy: Elevate gifting with our bath bombs—single-packs, multi-packs, and festive editions. A thoughtful boxed presentation for Halloween, birthdays, and more.",
  tags: [],
  msrpDollars: 9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:06.456Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
